<div class="text-center">
  <div>
    <span class="material-icons-round">check_circle</span>
  </div>
  <div>Password berhasil diubah, silahkan Login ulang</div>
</div>
